import ContentWrapper from '@/components/ContentWrapper';
import ImageComponent, { ImageType } from '@/components/Image';
import { BaseBlockComponentProps } from '@/types/block';
import { NextArray } from '@grace-studio/graceful-next/types';
import classNames from 'classnames';

type ImageBlockProps = BaseBlockComponentProps<{
  layout: 'full' | '2' | '3';
  images: NextArray<ImageType>;
}>;

const ImageBlock: ImageBlockProps = ({ block }) => {
  return (
    <ContentWrapper className="grid-base gap-y-4">
      {block.images.map((image, index) => (
        <ImageComponent
          className={classNames(
            index + 1 === block.images.length ? 'lg:col-end-13' : ''
          )}
          key={image._key}
          {...(block.layout === 'full'
            ? { ...image, orientation: 'landscape', size: 'full' }
            : image)}
        />
      ))}
    </ContentWrapper>
  );
};

export default ImageBlock;
